import { Link } from 'react-router-dom'
import CountdownTimer from '../components/CountdownTimer'
import { useEffect } from 'react'

export default function Home() {
  useEffect(() => {
    document.title = 'KALARAVA - PU 2nd Year Fest'
  }, [])

  return (
    <>
      <section className="min-h-screen flex items-center justify-center px-4 py-20">
        <div className="w-full max-w-4xl mx-auto">
          {/* Welcome */}
          <div className="animate-fade-up text-center mb-2">
            <p className="text-2xl md:text-3xl font-bold text-kala-primary">
              Welcome to
            </p>
          </div>

          {/* Logo */}
          <div className="animate-fade-up mb-2 flex justify-center" style={{ animationDelay: '0.05s' }}>
            <img 
              src="/kalarava-logo.png" 
              alt="KALARAVA Logo" 
              className="w-full max-w-2xl h-auto object-contain"
              style={{
                filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.15))',
                minHeight: '200px',
                maxHeight: '350px'
              }}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          </div>

          {/* Headline */}
          <div className="animate-fade-up text-center mb-10" style={{ animationDelay: '0.1s' }}>
            <p className="text-base md:text-lg text-kala-secondary mb-3">
              29 November 2025
            </p>
            <h1 className="text-3xl md:text-5xl font-bold text-kala-primary mb-3">
              KLE Society's College of BCA & BBA Gokak
            </h1>
            <p className="text-lg md:text-xl font-semibold text-kala-blue">
              For PU 2nd Year Science, Commerce & Arts Fest
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="animate-fade-up flex flex-col sm:flex-row gap-4 justify-center mb-12" style={{ animationDelay: '0.2s' }}>
            <Link to="/events" className="btn-gradient-blue-cyan text-center px-8 py-3 font-semibold">
              View Events
            </Link>
            <a
              href="https://forms.gle/KLEF3S1Ve5d5S9fv6"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gradient-orange-yellow text-center px-8 py-3 font-semibold"
            >
              Register Now
            </a>
          </div>

          {/* Countdown Timer */}
          <div className="animate-fade-up flex justify-center mb-16" style={{ animationDelay: '0.3s' }}>
            <CountdownTimer />
          </div>

          {/* About Section */}
          <div className="animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              {/* Left - Icons */}
              <div className="card-soft p-8 md:p-12 flex flex-col items-center justify-center gap-8 min-h-64">
                <div className="text-9xl">🎨</div>
                <div className="text-9xl">🎭</div>
                <div className="text-9xl">🎵</div>
              </div>

              {/* Right - Content */}
              <div className="space-y-8">
                {/* What is KALARAVA */}
                <div>
                  <h3 className="text-2xl font-bold text-kala-primary mb-3 flex items-center gap-2">
                    <span className="w-1 h-8 bg-gradient-to-b from-kala-blue to-kala-cyan rounded-full"></span>
                    What is KALARAVA?
                  </h3>
                  <p className="text-kala-secondary leading-relaxed">
                    KALARAVA is the annual cultural and academic fest organized by KLE Society's College of BCA & BBA, Gokak, for 2nd year students. It is a celebration of creativity, talent, and excellence across multiple disciplines, including arts, culture, media, literature, and technology.
                  </p>
                </div>

                {/* Eligibility */}
                <div>
                  <h3 className="text-2xl font-bold text-kala-primary mb-3 flex items-center gap-2">
                    <span className="w-1 h-8 bg-gradient-to-b from-kala-orange to-kala-yellow rounded-full"></span>
                    Eligibility
                  </h3>
                  <p className="text-kala-secondary leading-relaxed">
                    Open to all PU 2nd year students pursuing Science, Commerce, or Arts streams. All students are welcome to participate in one or more events.
                  </p>
                </div>

                {/* Our Purpose */}
                <div>
                  <h3 className="text-2xl font-bold text-kala-primary mb-3 flex items-center gap-2">
                    <span className="w-1 h-8 bg-gradient-to-b from-kala-cyan to-kala-blue rounded-full"></span>
                    Our Purpose
                  </h3>
                  <p className="text-kala-secondary leading-relaxed">
                    To provide a platform for students to showcase their talents, build confidence, make memories, and celebrate the vibrant culture of our college community.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  )
}
